export class APIsEndPoints {

     /*  public static readonly BASE_URL: string = 'http://localhost:3000/v1';
      public static readonly BASE_URL_V2: string = 'http://localhost:3000/v2';
      public static readonly FRONT_END_URL: string ="http://localhost:4300";   */
   
     public static readonly BASE_URL: string = 'https://ardmoresafetyratingapi.marinepals.com/v1';
     //public static readonly BASE_URL: string = 'http://ardmoresafetyrating.marinepals.com:3001/v1';
     public static readonly BASE_URL_V2: string = 'https://ardmoresafetyratingapi.marinepals.com/v2';
     //public static readonly BASE_URL_V2: string = 'http://ardmoresafetyrating.marinepals.com:3001/v2';
     // public static readonly BASE_URL: string = 'http://ardmoredev.marinepals.com:3001/v1';
     // public static readonly BASE_URL_V2: string = 'http://ardmoredev.marinepals.com:3001/v2';
     //public static readonly FRONT_END_URL: string ="http://ardmoredev.marinepals.com:8201";   
    
	public static readonly FRONT_END_URL: string ="https://ardmoresafetyratingapp.marinepals.com";   
	//public static readonly FRONT_END_URL: string ="http://ardmoresafetyrating.marinepals.com:8201";   

    public static readonly LOGIN = APIsEndPoints.BASE_URL + '/auth/login';
    public static readonly LOGOUT = APIsEndPoints.BASE_URL + '/auth/logout';
    public static readonly FORGOT_PASSWORD = APIsEndPoints.BASE_URL + '/auth/forgetPassword';
    public static readonly VALIDATE_TOKEN = APIsEndPoints.BASE_URL + '/auth/checkTokenValidity?token=';
    public static readonly CHANGE_PASSWORD = APIsEndPoints.BASE_URL + '/auth/changePassword';

    // Analtics APIs URLs
    public static readonly GET_LIST_ALL_SUGGESTION = APIsEndPoints.BASE_URL + '/ratings/listCrewRatingsByName';
    
    public static readonly GET_ALL_RATINGS = APIsEndPoints.BASE_URL + '/ratings/listRatings';
    public static readonly LIST_CREW_RATINGS = APIsEndPoints.BASE_URL + '/ratings/listCrewRatings';
    public static readonly GET_CREW_RATINGS = APIsEndPoints.BASE_URL + '/ratings/crewRatings';
    public static readonly GET_RATING_DETAILS = APIsEndPoints.BASE_URL + '/ratings/getRatingDetails';
    public static readonly GET_ALL_RANKS = APIsEndPoints.BASE_URL + '/ratings/getAllRanks';

    public static readonly GET_RATINGS_FIRM = APIsEndPoints.BASE_URL_V2 + '/ratings/listRatings';
    public static readonly GET_RATING_BY_FILTERS = APIsEndPoints.BASE_URL_V2 + '/ratings/ratingByfilters';
    public static readonly GET_QUESTIONS_AVG_RATING = APIsEndPoints.BASE_URL_V2 + '/ratings/ratingQuestionAvg';
    public static readonly GET_SETTINGS = APIsEndPoints.BASE_URL_V2 + '/setting';


    public static readonly GET_NOMINATIONS_DATA = APIsEndPoints.BASE_URL + '/nominations/all';
    public static readonly GET_NOMINATED_CREW_DETAILS = APIsEndPoints.BASE_URL + '/nominations';
    public static readonly UPDATE_SHORTLISTED_CREW_DETAILS = APIsEndPoints.BASE_URL + '/nominations/shortlist';
    public static readonly GET_SHORTLISTED_CREWS = APIsEndPoints.BASE_URL + '/nominations/shortlisted';
    public static readonly GENERATE_EMAIL_LINKS_FOR_VOTING = APIsEndPoints.BASE_URL + '/nominations/generate-links';
    public static readonly RESET_FOR_SHORTLISTING= APIsEndPoints.BASE_URL + '/nominations/reset';
    public static readonly SUBMIT_VOTE_FOR_CANDIDATE= APIsEndPoints.BASE_URL + '/nominations/vote';
    public static readonly GET_VOTING_DETAILS_BY_VOTER= APIsEndPoints.BASE_URL + '/nominations/vote';
    public static readonly SUBMIT_COMMENT_FOR_CANDIDATE= APIsEndPoints.BASE_URL + '/nominations/addcomment';
    public static readonly SUBMIT_COMMENT_FOR_CANDIDATE_BY_ADMIN= APIsEndPoints.BASE_URL + '/nominations/addcommentbyAdmin';
    public static readonly GET_ALL_COMMENTS_FOR_CANDIDATE= APIsEndPoints.BASE_URL + '/nominations/getallcommentsforcandidate';
    public static readonly DECLARE_WINNER_FOR_PERIOD= APIsEndPoints.BASE_URL + '/nominations/winner';
    public static readonly GET_ALL_WINNERS_DATA= APIsEndPoints.BASE_URL + '/nominations/allwinners';
    public static readonly CHECK_PDF_EXISTS= APIsEndPoints.BASE_URL + '/nominations/check-pdf';
    public static readonly UPLOAD_FINAL_REPORT= APIsEndPoints.BASE_URL + '/nominations/uploads';
    public static readonly MARK_FAVORITE= APIsEndPoints.BASE_URL + '/nominations/favorite';
    public static readonly DELETE_NOMINATION_BY_ID= APIsEndPoints.BASE_URL + '/nominations';
}

